import { BRAND_NAME, language } from "@chef/constants";

export const intl = (
  {
    no: {
      CHECK_OUT: "Se",
      MENU: "ukemeny!",
      LOOK_WHAT_I_HAVE_ORDERED_FOR_WEEK:
        "Se hvilke retter jeg har valgt til uke",

      GOOD_TO_HAVE_AT_HOME: "Bra å ha hjemme",
      DINNERS: "middager",
      PORTIONS: "pers",
      DISHES: "Retter",
      CHECK_OUT_MY_MENU: "Se min meny",
    },
    se: {
      CHECK_OUT: "Se",
      MENU: "veckomeny!",
      LOOK_WHAT_I_HAVE_ORDERED_FOR_WEEK:
        "Se vilka rätter jag har valt till vecka",

      GOOD_TO_HAVE_AT_HOME: "Bra att ha hemma",
      DINNERS: "middagar",
      PORTIONS: "pers",
      DISHES: "Rätter",
      CHECK_OUT_MY_MENU: "Se min meny",
    },
    dk: {
      CHECK_OUT: "Se",
      MENU: "ugemenu!",
      LOOK_WHAT_I_HAVE_ORDERED_FOR_WEEK:
        "Se, hvilke retter jeg har valgt til uge",

      GOOD_TO_HAVE_AT_HOME: "Godt at have derhjemme",
      DINNERS: "retter",
      PORTIONS: "pers",
      DISHES: "Retter",
      CHECK_OUT_MY_MENU: "Se min menu",
    },
  } as const
)[language];

export const brand = (
  {
    AMK: {
      YOU_RECEIVE_THIS_MENU_FROM_ACTIVE_USER_OF:
        "Du har fått denne ukemenyen av en kunde hos Adams Matkasse",
    },
    GL: {
      YOU_RECEIVE_THIS_MENU_FROM_ACTIVE_USER_OF:
        "Du har fått denne ukemenyen av en kunde hos Godtlevert!",
    },
    LMK: {
      YOU_RECEIVE_THIS_MENU_FROM_ACTIVE_USER_OF:
        "Du har fått den här veckomenyn av en kund hos Linas Matkasse!",
    },
    RN: {
      YOU_RECEIVE_THIS_MENU_FROM_ACTIVE_USER_OF:
        "Du har modtaget denne ugemenu fra en kunde hos RetNemt Måltidskasser!",
    },
  } as const
)[BRAND_NAME];
